import { render } from "./TheSiteDescription.vue?vue&type=template&id=72177c1f&scoped=true&ts=true"
import script from "./TheSiteDescription.vue?vue&type=script&lang=ts"
export * from "./TheSiteDescription.vue?vue&type=script&lang=ts"

import "./TheSiteDescription.vue?vue&type=style&index=0&id=72177c1f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72177c1f"]])

export default __exports__